import React, { PropsWithChildren, Suspense } from 'react';
import { Navigate } from 'react-router-dom';

import { PageLoading } from '@/components/layout/routes/PageLoading.comp.tsx';
import { useUserContext } from '@/contexts/userContext/User.context.ts';
import { RouteEnum } from '@/models/route/Route.model.ts';
import { hasRequiredPermissions, type RequiredPermissions } from '@/utils/permissions.util.ts';

interface Props extends PropsWithChildren {
  requiredPermissions: RequiredPermissions;
}

export const RouteGuard: React.FC<Props> = props => {
  const { children, requiredPermissions } = props;
  const { permissions } = useUserContext();
  const userPermissions = (permissions as string[]) ?? [];

  if (!hasRequiredPermissions(userPermissions, requiredPermissions)) {
    return <Navigate replace to={RouteEnum.FORBIDDEN} />;
  }

  return <Suspense fallback={<PageLoading />}>{children}</Suspense>;
};
